/* 
 *  DESERTLAND SERVICE
 *  @author: jd@cals.arizona.edu
 * 
 * json:
 * 
 * https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/
 * pages.json
 * tips.json
 * resource.json
 * invasives.json
 * trivia.json
 * 
 * nid.json
 * 
 * Here’s the json currently being pulled in the webapp frontend:
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/pages.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/tips.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/tips_desc.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/resource.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/landscapes.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/biblio.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/trivia.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/invasives.json
 
https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/json/  [nid].json (each plant nid in the plant selector)
 

 * 
 */
import { Config, SiteRoot } from './desertland.init';
import { saveToStorage, getFromStorage } from './cals.storage';
import { Utils } from './cals.utils';

declare var log, info, warn, groupCollapsed, groupEnd;
/* tslint:disable no-var prefer-const */
    
// console.log("DESERTLAND.Service.js > go dao");

export class Service {

  public static webServiceEndpoint = (function () {
    // var webServiceEndpoint = "json/"; //localhost
    // var sitePath = (Config 
    //                 && Config.prodPath 
    //                 && Config.json 
    //                 && Config.json.useLocalDevData === false) ? DESERTLAND.utils.strEndsWithSlash(Config.prodPath) : DESERTLAND.utils.strEndsWithSlash(SiteRoot);
    let jsonPath = "webservice/sites/desertlandscaping.arizona.edu.webservice/json/"; // prod default
    
    if (!Utils.isEmpty(Config) && !Utils.isEmpty(Config.json) && !Utils.isEmpty(Config.json.endpoint) && Config.json.endpoint.length > 0) {
      jsonPath = Config.json.endpoint;
    } else {
      info("config.json.endpoint not found - using default: ",jsonPath);
    }
    return jsonPath;
  })();

  public localStorageAPI = localStorageAPI;

  public load = {

    pages(callback) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'pages.json');
    },

    plant(callback, nid) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + nid + '.json');
    },

    plantFilters(callback) {
      getJson(callback, '/json/plant-selector-filters.json');
    },

    tips(callback) {
      const next = (data) => {
        log("got the tips data, getting descs..");
        getJson(callback, SiteRoot + Service.webServiceEndpoint + 'tips_desc.json', data);
      };
      getJson(next, SiteRoot + Service.webServiceEndpoint + 'tips.json');
    },

    learnmore(callback) {
      // const next = (data) => {
      //   log("got the learnmore data, getting descs..");
      //   getJson(callback, SiteRoot + Service.webServiceEndpoint + 'learnmore_desc.json', data);
      // };
      // getJson(next, SiteRoot + Service.webServiceEndpoint + 'learnmore_desc.json');
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'learnmore_desc.json');
    },

    resources(callback) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'resource.json');
    },

    ideas(callback) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'landscapes.json');
    },

    biblio(callback) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'biblio.json');
    },

    trivia(callback) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'trivia.json');
    },

    invasives(callback) {
      getJson(callback, SiteRoot + Service.webServiceEndpoint + 'invasives.json');
    }

  };


  public getJson = getJson;


  /// POST
  public postJson = (serviceMethod, callback, data, endpoint) => {

    if (typeof data === "undefined") {
      data = {
        method: serviceMethod
      };
    } else {
      data.method = serviceMethod;
    }
    if (typeof endpoint === "undefined") {
      endpoint = Service.webServiceEndpoint;
    }

    //log(data);

    let jqxhrPost = $.post(endpoint, data, function (response) {
      let json = null;
      try {
        json = JSON.parse(response);
      } catch (e) {
        // continue regardless 
      }
      if (json !== null) {
        log("jqxhr [%s] success : json = %o", serviceMethod, json);
      } else {
        log("jqxhr [%s] success : data (!json) = %o", serviceMethod, response);
      }


      if (typeof callback === "undefined") {
        return response;
      } else {
        callback(response);
      }


    })
      .fail(function (jqxhr, textStatus, error) {
        console.error("jqxhr error (" + serviceMethod + "): " + textStatus + ", " + error);
        // })
        // .done(function() {
        //     //log( "jqxhr second success" );
        // })
        // .always(function() {
        //     //log( "jqxhr always" );
      });
  }


}

// GET
export const getJson = (callback, endpoint, payload?) => {

  if (typeof endpoint === "undefined") {
    endpoint = Service.webServiceEndpoint;
  }

  let jqxhrGet = $.getJSON(endpoint, function (data) {
    let json = null;
    try {
      json = JSON.parse(data);
    } catch (e) {
      //log(e);
    }
    if (json !== null) {
      log("jqxhr [%s] success : json = %O", endpoint, json);
    } else {
      log("jqxhr [%s] success : data = %O", endpoint, data);
    }

    if (typeof callback === "undefined") {
      info("no callback identified for getJson [%s]", endpoint);
      //return data;
    } else {
      callback(data, payload);
    }


  })
    .fail(function (jqxhr, textStatus, err) {
      console.error("jqxhr error (" + endpoint + "): " + textStatus + ", " + err);
      if (typeof callback === "function") {
        callback(false, payload);
      }
    });
  /*.done(function() {
      //log( "jqxhr second success" );
  })
  .always(function() {
      //log( "jqxhr always" );
  })*/

};

export const localStorageAPI = {

  save(variable, value, bIsObjOrArray, doLog = false) {
    saveToStorage(variable, value, bIsObjOrArray, doLog);
  },
  get(variable, bIsObjOrArray, doLog = false) {
    return getFromStorage(variable, bIsObjOrArray, doLog);
  }
};



// DESERTLAND.logLocalStorageSize = CALSSTOR.logLocalStorageSize;
// export const logLocalStorageSize = CALSSTOR.logLocalStorageSize;

// module.exports = {
    
//    webServiceEndpoint: webServiceEndpoint,
//    postJson: postJson,
//    getJson: getJson,
//    localStorageAPI : api_localStorage,
   
//    load: loadJson

// };      
